import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// captures a required reason for a booking action (cancel / reject) and returns
// it via dialogRef.close(reason). data = { title, actionLabel }.
@Component({
  selector: 'app-booking-action-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './booking-action-dialog.component.html',
  styleUrls: ['./booking-action-dialog.component.scss', '../../../../common-style/ac-dialog.scss'],
})
export class BookingActionDialogComponent {
  reason: string = '';

  constructor(
    public dialogRef: MatDialogRef<BookingActionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; actionLabel: string }
  ) {}

  submit(): void {
    if (!this.reason.trim()) return;
    this.dialogRef.close(this.reason.trim());
  }

  close(): void {
    this.dialogRef.close();
  }
}
